import { getAccessToken } from '../../../selectors/personalPensionPlan/payments';
import { getIsApiPending } from '../../../selectors/personalPensionPlan/nextOfKin';
import { getNextOfKinForm } from '../../../selectors/personalPensionPlan/nextOfKin';

import axios from 'axios';
import { getCustomerIdValue } from '../../../selectors/personalPensionPlan/personalDetails';
import { apiTransitionNextOfKinForm } from "../../../actions/personalPensionPlan/nextOfKin";
import { setExpiredAuth } from '../../../actions/personalPensionPlan/quote';

export const payloadNextOfKinService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionNextOfKinForm.pending());
            try {
                const resp = await makeSubmission(store.getState());
                if (resp.data) {
                    store.dispatch(apiTransitionNextOfKinForm.success());
                }
            } catch (e) {
                console.error(e);
                if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
                    store.dispatch(setExpiredAuth(true));
                }
                store.dispatch(apiTransitionNextOfKinForm.failure());
            }
        }
    })();
    return next(action);
}

const payloadCollection = (state) => {

    const nextOfKin = getNextOfKinForm(state);
    const pid = getCustomerIdValue(state)
    const payload = {
        pension_id: pid.value,
        firstName: nextOfKin.firstName?.value || 'N/A',
        lastName: nextOfKin.lastName?.value || 'N/A',
        idNumber: nextOfKin.idNumber?.value || 'N/A',
        relationship: nextOfKin.relationship?.value || 'N/A',
        phoneNumber: nextOfKin.phoneNumber?.value || 'N/A',
        emailAddress: nextOfKin.email?.value || 'N/A',
    }

    return {
        ...payload
    }
}

const makeSubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/personal-pension-plan/nextofkin';
        return await axios.post(url, payloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};